import './select-day.css'
import React from 'react'
import { HiChevronLeft } from "react-icons/hi";
import { HiChevronRight } from "react-icons/hi";
import { HiOutlineCalendar } from "react-icons/hi";

const SelectDay = () => {
    return (
        <div>
            <div className='container-week'>

                <div className='icon'>
                    <HiChevronLeft />
                </div>

                <div className='container-day'>
                    <p className='week app-little-text'>Seg</p>
                    <p className='number app-little-title '>02</p>
                    <p className='month app-little-text'>Abr</p>
                </div>

                <div className='container-day selected'>
                    <p className='week app-little-text'>Ter</p>
                    <p className='number app-little-title '>03</p>
                    <p className='month app-little-text'>Abr</p>
                </div>

                <div className='container-day'>
                    <p className='week app-little-text'>Qua</p>
                    <p className='number app-little-title '>04</p>
                    <p className='month app-little-text'>Abr</p>
                </div>

                <div className='container-day'>
                    <p className='week app-little-text'>Qui</p>
                    <p className='number app-little-title '>05</p>
                    <p className='month app-little-text'>Abr</p>
                </div>

                <div className='container-day'>
                    <p className='week app-little-text'>Sex</p>
                    <p className='number app-little-title '>06</p>
                    <p className='month app-little-text'>Abr</p>
                </div>

                <div className='container-day'>
                    <p className='week app-little-text'>Sab</p>
                    <p className='number app-little-title '>07</p>
                    <p className='month app-little-text'>Abr</p>
                </div>

                <div className='icon'>
                    <HiChevronRight />
                </div>
            </div>

            <div className='complete-date'>
                <span className='icon'><HiOutlineCalendar /></span>
                <span className='app-little-text'>Sexta-feira, 12 de junho de 2026</span>
            </div>
            
        </div>

    )
}

export default SelectDay